
interface Club {
    id: number;
    name: string;
    divisionNumber: number;
    clubNumber: number;
}

const ClubDefaults: Club = {
    id: 0,
    name: '',
    divisionNumber: 0,
    clubNumber: 0,
}

export {
    Club,
    ClubDefaults
}